<template>
<div class="mt-5">
  <h2 class="mb-3">Dúvidas frequentes</h2>
  <dl class="">
    <dt>1. Há alguma fidelidade ou contrato mínimo para os planos da MIRT? </dt>
    <dd>Não, nossos planos não têm fidelidade nem tempo mínimo de contrato. Você pode contratar e cancelar a qualquer momento. </dd>

    <dt>2. Como faço para cancelar meu plano? </dt>
    <dd>O cancelamento pode ser realizado a qualquer momento acessando as configurações da conta e clicando em "Gerenciar Conta" e depois em "Meu Plano". Após o cancelamento, você ainda terá acesso ao plano até o final ao contrato eminente. </dd>

    <dt>3. Quais são as formas de pagamento aceitas? </dt>
    <dd>Aceitamos PIX, cartão de crédito e boleto bancário como formas de pagamento. </dd>

    <dt>4. Como funciona a cobrança dos valores no primeiro mês? </dt>
    <dd>A mensalidade do plano e dos adicionais são cobradas de forma proporcional no primeiro mês, com base no período utilizado até o final do contrato eminente. </dd>

    <dt>5. É possível alterar meu plano após contratá-lo? </dt>
    <dd>Sim, você pode fazer um upgrade ou downgrade do seu plano a qualquer momento. Basta acessar as configurações, selecionar "Meu Plano" e fazer as alterações desejadas. </dd>

    <dt>6. Posso adicionar serviços extras ao plano gratuito? </dt>
    <dd>Sim, é possível adicionar serviços extras ao plano gratuito. Nesse caso, você será cobrado apenas pelos adicionais contratados.</dd>

    <dt>7. O que acontece se eu decidir cancelar após adquirir um adicional? </dt>
    <dd>Mesmo após o cancelamento, você ainda terá acesso aos serviços do adicional até o final do contrato eminente.</dd>

    <dt>8. Se eu fizer um downgrade, serei reembolsado pela diferença? </dt>
    <dd>Não, o serviço ou acesso permanecerá ativo até o término do contrato em questão. Após isso, será realizado o downgrade e o novo faturamento será baseado no novo contrato.</dd>

    <dt>9. Como funcionam os ciclos de cobrança? São mensais? </dt>
    <dd>Sim, as cobranças são feitas mensalmente. Você pode visualizar todas as faturas acessando as configurações e indo para a seção "Faturas".</dd>

    <dt>10. Quanto tempo leva para os adicionais serem ativados em minha conta após a compra? </dt>
    <dd>Os adicionais são ativados conforme o período especificado na descrição de cada serviço, após a confirmação do pagamento.</dd>

    <dt>11. Posso usar mais de uma forma de pagamento?  </dt>
    <dd>Sim, no momento da contratação de cada serviço, você pode escolher o método de pagamento de sua preferência. Nas mensalidades subsequentes, tudo é consolidado em uma única fatura, oferecendo a conveniência de ter uma única opção de pagamento. </dd>

    <dt>12. Em caso de problemas com o pagamento, há um período de carência antes de meu serviço ser interrompido? </dt>
    <dd>Oferecemos um período de carência de 7 dias antes da interrupção de acesso ao sistema.</dd>
  </dl>
</div>
</template>
<script>
export default {
  name: 'duvidas-frequentes'
}
</script>
<style scoped>
dt {
  margin-top: 20px;
  font-size: 1.2rem;
}

dd {
  font-size: 1rem;
}
</style>
